import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api, { mediaUrl } from "@/lib/api";

export default function TestimonialFeature() {
  const [t, setT] = useState(null);
  useEffect(() => {
    api
      .get("/testimonials")
      .then(({ data }) => {
        const featured = (data || []).find((x) => x.featured) || (data || [])[0];
        setT(featured || null);
      })
      .catch(() => {});
  }, []);

  if (!t) return null;

  return (
    <section
      data-testid="testimonial-feature"
      className="bg-ink text-ivory py-24 md:py-40 border-t border-ivory/5"
    >
      <div className="mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-12 gap-8 items-center">
        {t.client_photo && (
          <motion.div
            className="col-span-12 md:col-span-4"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <div className="photo-frame aspect-[3/4]">
              <img src={mediaUrl(t.client_photo)} alt={t.client_name} loading="lazy" />
            </div>
          </motion.div>
        )}
        <div className={`col-span-12 ${t.client_photo ? "md:col-span-8" : ""}`}>
          <p className="label-mono opacity-60 line-badge">04 — In their words</p>
          <motion.blockquote
            className="mt-8 font-editorial text-4xl md:text-6xl leading-[1.1] max-w-4xl"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.1 }}
            data-testid="testimonial-quote"
          >
            <em className="italic">"{t.quote}"</em>
          </motion.blockquote>
          <div className="mt-10 flex items-center gap-4">
            <span className="w-10 h-px bg-ivory/40" />
            <p className="label-mono">
              {t.client_name} · {t.service_category}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
